export const PREMIUM_CONTEST_IG_POST_URL = 'https://www.instagram.com/p/DcwlWEjx5I-/'

/** Contest ends at 2026-09-07T00:00:00.000Z (midnight between Sept 6 and 7, UTC). */
export const PREMIUM_CONTEST_END_MS = Date.UTC(2026, 8, 7, 0, 0, 0)

export const PREMIUM_CONTEST_BANNER_DISMISSED_STORAGE_KEY = 'premiumContestBannerDismissed'

export function isPremiumContestActive(now: Date = new Date()): boolean {
  return now.getTime() < PREMIUM_CONTEST_END_MS
}

export function openPremiumContestPost(): void {
  window.open(PREMIUM_CONTEST_IG_POST_URL, '_blank', 'noopener,noreferrer')
}
